import React from "react";

const ImageEmployeeLock = () => {
	return (
		<svg
			className="image-employee-unlock unclickable"
			width="24"
			height="24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 3a5 5 0 0 1 4.995 4.783L17 8v3h2v9H5v-9h2V8a5 5 0 0 1 5-5zm2.5 9.5h-5v6h5v-1.2h-3.75v-1.2h3.75v-1.2h-3.75v-1.2h3.75v-1.2zM12 5a3 3 0 0 0-2.995 2.824L9 8v3h6V8a3 3 0 0 0-3-3z"
				fill="#aa0061"
				fillRule="evenodd"
			/>
		</svg>
	);
};

export default ImageEmployeeLock;
